import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-authz-access-hint-footer',
  templateUrl: './authz-access-hint-footer.component.html',
  styleUrls: ['./authz-access-hint-footer.component.css'],
})
export class AuthzAccessHintFooterComponent {
  @Input() authzAccessHint: { message: string; requestUrl: string } | null = null;
}
